import Axios from 'axios'
import {getCookie, graphQLURL, graphQLToken} from '../../utils/common';

export const fetchMatrixDirections = () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL;
  const token = getCookie('securityToken') || graphQLToken;
  const query = {

    query: `
      query {
        tradingMatrixDirections {
          status
          name
	    }
    }`
  }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, CONTENT_TYPE)
}

export const fetchMatrixIvs = () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL;
  const token = getCookie('securityToken') || graphQLToken;
  const query = {
    query: `
      query {
        tradingMatrixIvs {
          status
          name
	    }
    }`
  }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, CONTENT_TYPE)
}

export const fetchtradingMatrixStrategies = () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL;
  const token = getCookie('securityToken') || graphQLToken;
  const query = {
    query: `
      query {
        tradingMatrixStrategies {
          status
          name
          tradingMatrixIvs {
            name
          }
          tradingMatrixDirections {
            name
          }
	    }
    }`
  }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, CONTENT_TYPE)
}

export const fetchtradingMatrixTargetLists = () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL;
  const token = getCookie('securityToken') || graphQLToken;
  const query = {
    query: `
      query {
        tradingMatrixTargetLists {
           	status
            symbol
            startDate
            endDate
            tradingMatrixIvs {
              name
            }
            tradingMatrixDirections {
              name
            }
            description
			}
    }`
  }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, CONTENT_TYPE)
}


// WEBPACK FOOTER //
// ./src/actions/tradeMatrix/index.js